import type SinatraState from '../types/SinatraState';

type UserState = SinatraState['user'];

/**
 * Return a logged-in user's organizations, or undefined when there is no
 * profile to read from — "unknown" stays distinct from "belongs to none".
 *
 * The type promises an organizations array; production delivers isLoggedIn:
 * true with none, so the guard stays even though the type calls it unreachable.
 */
export function selectUserOrganizations(user: UserState) {
  if (!user?.isLoggedIn) {
    return undefined;
  }
  const { organizations } = user.profile ?? {};
  return Array.isArray(organizations) ? organizations : undefined;
}

export default selectUserOrganizations;
